export default __webpack_public_path__ + "static/media/workflow.5aa897b2.svg";